<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-11-16 11:23:17
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterRecord\components\ExportOut.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-16 10:57:21
-->
<template>
  <normalDialog
    :dialog="show"
    width="680"
    :title="$t('label_essweb_RosterRecord_dialog_ExportOutTitle')"
    maxWidth="680"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row dense>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              v-model="selectStaff"
              :items="curStaffs"
              label="label_essweb_RosterRecord_dialog_staffLabel"
              chips
              :filter="$staffFilter"
              deletable-chips
              avatar
              two-line
              multiple
              :rules="$GetRules(['_Require_ArrRules'], [null])"
              item-text="staff_code"
              item-value="staff_id"
            >
              <template v-slot:selection.avatar="{ data }">
                <StaffAvatar
                  size="36"
                  left
                  contentClass="white--text"
                  :src="data.item.staff_avatar"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </template>
              <template v-slot:item.avatar="{ data }">
                <StaffAvatar
                  size="36"
                  :src="data.item.staff_avatar"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:item.title="{ data }">
                <span class="text-body-2"
                  >{{ $getCommonLangValue(data.item.preferred_name) }}
                  <span class="text--secondary text-caption-xs">{{
                    data.item.staff_code
                  }}</span></span
                >
              </template>
              <template v-slot:item.subtitle="{ data }">
                {{ $getCommonLangValue(data.item.job_post_name) }}
              </template>
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_RosterRecord_dialog_dateLabel")
            }}</v-sheet>
            <DateTimePicker
              isRequire
              type="daterange"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :value="curtime"
              :defaultStartTime="defaultStartDate"
              :defaultEndTime="defaultEndDate"
              :placeholder="$t('label_essweb_RosterRecord_list_seTimeLabel')"
              @change="
                (time, isre) => {
                  curtime = time;
                  if (isre) {
                    defaultStartDate = time ? time.split(' - ')[0] : '';
                    defaultEndDate = time ? time.split(' - ')[1] : '';
                  }
                }
              "
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions
        saveText="label_essweb_RosterRecord_list_exportOutBtnLabel"
        saveBtn
        @save="toSubmit"
        @cancel="closeDialog"
      />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ExportOut",
  props: {
    show: { default: false, type: Boolean },
  },
  computed: {
    ...mapGetters(["companyLang"]),
  },
  watch: {
    show(val) {
      if (val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.curtime = "";
        this.selectStaff = [];
        this.defaultStartDate = "";
        this.defaultEndDate = "";
      }
    },
  },
  data() {
    return {
      curtime: "",
      curStaffs: [],
      selectStaff: [],
      defaultStartDate: "",
      defaultEndDate: "",
    };
  },
  mounted() {
    this.getStaffs();
  },
  methods: {
    toSubmit() {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit(
        "export",
        this.selectStaff,
        this.defaultStartDate,
        this.defaultEndDate
      );
    },
    removeStaff: function (item) {
      const index = this.selectStaff.indexOf(item.staff_id);
      if (index >= 0) this.selectStaff.splice(index, 1);
    },
    getStaffs: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/get-staff-select/",
        data: { type: 2 },
      }).then((res) => {
        that.curStaffs = res.data;
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },
  },
};
</script>